import { api } from './api'
import type { Season } from './types'

export type AdminState = {
  editions?: number[]
  eventDates?: Array<{ edition: number; date: string }>
  openSeatingActivatedAt: string | null
  waitlistActive: boolean
  season: Season & { persisted?: boolean }
  registrationCounts: {
    total: number
    buurtbewoners: number
    nogGeenPlek: number
    feedbackOntvangen?: number
    nogNietBevroren?: number
    nogNietBevrorenEdities?: Array<{ edition: number; count: number }>
  }
  countsError?: string | null
}

// /beheer bestaat uit losse kaarten die elk een stukje van deze route nodig
// hebben (seizoen, marktdatum, fase 2, wachtlijst, de editie-kiezer). Ze
// haalden hem elk apart op — vijf identieke requests per paginalading, elk
// met een volledige gepagineerde listAll() tegen Notion, dat op ~3 requests
// per seconde zit.
//
// Er is nu één ophaler: `Inner` in Beheer.tsx doet deze call en geeft het
// resultaat door. Bewust géén gedeelde cache of in-flight-truc in deze
// module: de kaarten mounten pas nádat `Inner` zijn eerste lading binnen
// heeft (tot dan staat er "Laden…"), dus een gedeelde vlucht is tegen die
// tijd al afgelopen en levert gewoon een tweede request op. Alleen echt
// doorgeven werkt.
export function fetchAdminState(token: string) {
  return api<AdminState>('/api/admin/state', { headers: { Authorization: `Bearer ${token}` } })
}
